import { render } from "./PingGuView.vue?vue&type=template&id=4ca796a0&scoped=true&ts=true"
import script from "./PingGuView.vue?vue&type=script&lang=ts"
export * from "./PingGuView.vue?vue&type=script&lang=ts"

import "./PingGuView.vue?vue&type=style&index=0&id=4ca796a0&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca796a0"]])

export default __exports__